module.exports = __webpack_public_path__ + "img/19.79a75405.jpg";